import { StrictMode } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { useZoomAwareTheme } from "@thalamos/frontend";

import { config } from "./config/index.js";
import { NotificationsProvider } from "./hooks/useNotifications/index.js";

import "./i18n.js";

import { PusherProvider } from "./lib/pusher/core/PusherProvider.js";
import { createRouter } from "./routing/createRouter.js";
import {
  theme as defaultTheme,
  notificationsSlotProps,
} from "./theme/defaultTheme.js";
import { initialiseTracing } from "./tracing.js";

// Create global singletons
const router = createRouter();

initialiseTracing();

const App = () => {
  const theme = useZoomAwareTheme(defaultTheme);

  return (
    <StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <PusherProvider {...config.pusher}>
          <NotificationsProvider slotProps={notificationsSlotProps}>
            <RouterProvider router={router} />
          </NotificationsProvider>
        </PusherProvider>
      </ThemeProvider>
    </StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />,
);
